
import { Routes } from '@angular/router';
import { ActionPortalService } from './admin/features/action-portal/services/action-portal.service';
import { LoginComponent } from './Auth/components/login/login.component';
import { AuthGuard } from './Auth/guards/auth.guard';
import { AdminGuard } from './Auth/guards/role.guard';
import { ForgotPasswordComponent } from './Auth/components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './Auth/components/reset-password/reset-password.component';
import { MapCreateSiteComponent } from './spatial/pages/map-create-site/map-create-site.component';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(c => c.routes),
    providers:[ActionPortalService],
    canActivate:[AuthGuard,AdminGuard],
    data: { animation: true }
  },
  {
    path: 'create-site',
    component: MapCreateSiteComponent,
    data: { animation: true }
  },
  {
    path: 'login',
    component:LoginComponent
  },
  {
    path: 'forgot-password',
    component:ForgotPasswordComponent,
    providers: [ActionPortalService]
  },
  {
    path: 'reset-password',
    component:ResetPasswordComponent,
    providers: [ActionPortalService]
  },
  {
    path: '',
    loadChildren: () => import('./core/core.routes').then(r => r.routes),
    providers:[ActionPortalService],canActivate:[AuthGuard],
  }
];
